"use strict";

module.exports = require("./Unsplash.js");